<script setup>

import {onMounted, ref} from "vue";
import reportView from './report.vue'

const emit = defineEmits(['close'])

const props = defineProps({
    domain: {
        type: [String, null],
        required: false,
        default: '',
    },
    showIn: {
        type: String,
        required: false,
        default: 'slideout',
    },
    loadOnMount: {
        type: Boolean,
        required: false,
        default: true,
    }
})

const notAvailable = ref(false)
const loading = ref(false)
const report = ref(null)
const updatedAt = ref(null)
const retries = ref(0)

const loadReport = async () => {
    if (! props.domain || props.domain === '') {
        return
    }

    loading.value = true

    try {
        const res = await axios.post(route('add-insights.domain'), {
            domain: props.domain,
        })

        if (res.data.available === false) {
            notAvailable.value = true
        }
        loading.value = false
        report.value = res.data.report?.data
        updatedAt.value = res.data.report?.updated_at.split('T')[0]
    } catch (e) {
        if (retries.value < 3) {
            retries.value++

            setTimeout(function() {
                loadReport()
            }, 30000)
        }
    }
}

const onClose = () => {
    notAvailable.value = false
    loading.value = false
    report.value = null
    emit('close')
}

onMounted(() => {
    if (props.loadOnMount) {
        loadReport()
    }
})

defineExpose({loadReport})
</script>
<template>
    <div v-if="showIn === 'slideout'">
        <slideout-with-slots
            v-if="notAvailable || report || loading"
            title="Insights"
            @close="onClose"
            max-width-class="max-w-4xl"
        >
            <template #body>
                <div
                    v-if="loading"
                >
                    <mf-spinner-medium
                        class="w-24 h-12"
                    ></mf-spinner-medium>
                    <p class="text-center text-gray-400">Loading report, please wait...</p>
                </div>

                <div class="-mx-4 lg:-mx-6">
                    <reportView
                        v-if="report"
                        :report="report"
                        :updated-at="updatedAt"
                        :domain="props.domain"
                        :section-container="'div'"
                        section-class="pb-8 border-b"
                    />
                </div>
            </template>
        </slideout-with-slots>
    </div>
</template>
